
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface EmptyStateProps {
  searchTerm: string;
  selectedDate: Date | undefined;
}

const EmptyState = ({ searchTerm, selectedDate }: EmptyStateProps) => {
  const { language } = useLanguage();
  
  return (
    <div className="text-center p-12 border rounded-lg bg-background/50 shadow-sm">
      <h3 className="font-medium text-lg">{t('entries.noEntriesFound', language)}</h3>
      {searchTerm || selectedDate ? (
        <p className="text-muted-foreground mt-1">
          {t('entries.noEntriesMatch', language)}
        </p>
      ) : (
        <div className="mt-2">
          <p className="text-muted-foreground">
            {t('entries.noEntriesYet', language)}
          </p>
          <Button asChild className="mt-4 animate-pulse">
            <Link to="/generate">
              {t('entries.createFirstEntry', language)}
            </Link>
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
